import { DeviceScreenSize } from '../../constants';
import isMobileDisplay from '../mobile/check';
const initUpdateDetailsTagOpening = () => {
    let hasInit = false;
    let prevIsMobile = isMobileDisplay(DeviceScreenSize.Tablette);
    const detailsTags = document.querySelectorAll('footer details');
    const update = () => {
        const isMobile = isMobileDisplay(DeviceScreenSize.Tablette);
        const shouldUpdate = prevIsMobile !== isMobile || !hasInit;
        if (shouldUpdate) {
            detailsTags.forEach((tag) => {
                tag.open = !isMobile;
                if (!isMobile) {
                    const content = tag.querySelector('[data-footer-accordion-content]');
                    if (content) {
                        content.style.removeProperty('height');
                        content.style.removeProperty('visibility');
                    }
                }
            });
            prevIsMobile = isMobile;
            hasInit = true;
        }
    };
    if (detailsTags?.length > 0) {
        // Call immediately to handle cases where DOMContentLoaded has already fired
        update();
        window.addEventListener('resize', update);
    }
    return update;
};
export const updateDetailsTagOpening = initUpdateDetailsTagOpening();
